/**
 * Unique identifier for ARC4U partner used in internal systems
 * @example
 * ```typescript
 * import { ARC4U_IDENTIFIER } from '@renegkit';
 *
 * if (partner === ARC4U_IDENTIFIER) {
 *   // ARC4U specific logic
 * }
 * ```
 */
export const ARC4U_IDENTIFIER = 'arc4u';

/**
 * Display name for ARC4U partner
 */
export const ARC4U_PARTNER_NAME = 'ARC4';

/**
 * Display name for LuizaCred (Magalu) partner
 */
export const MAGALU_PARTNER_NAME = 'Magazine Luiza';


/**
 * Display name for Ativos partner
 */
export const ATIVOS_PARTNER_NAME = 'Ativos';
